import React from "react";
import { MenuItem, Select } from "@mui/material";

const CurrencySelector = ({ currency, setCurrency }) => (
  <Select
    value={currency}
    onChange={(e) => setCurrency(e.target.value)}
    sx={{ height: "30px", fontSize: "14px", minWidth: "70px" }}
  >
    {/* <MenuItem value="INR">INR</MenuItem> */}
    <MenuItem value="USD">USD</MenuItem>
  </Select>
);

export default CurrencySelector;
